import React, { useEffect, useState }  from 'react';
import ReactDOM from 'react-dom';
import { SEOStripContainer } from '../../../../shared/src/components/SEOStrip/SEOStripContainer';
import { emptyChildren } from '../../hooks/use-empty-children.hook';

export const VerticalSEOStrip = ({ changedVerticalOnClick }) => {
    const [portal, setPortal] = useState(null);

    // get and save target element for portal
    useEffect(() => {
        if (changedVerticalOnClick) {
            const portalElement = document.getElementById('asg-vertical-seo-strip-portal');

            if (portalElement && !portal) {
                emptyChildren(portalElement);
                setPortal(portalElement);
            }
        }
    }, [changedVerticalOnClick]);

    if (!portal) {
        return null;
    }

    return ReactDOM.createPortal((
        <SEOStripContainer />
    ), portal);
};
